import { useEffect } from "react";
import { useLocalStorage } from "@/hooks/useLocalStorage";
import { useProfile } from "@/hooks/firestore/user/useProfile";
import { useUserId } from "@/features/auth/hooks/useUserId";
import { USER_VERIFIED_STATUSES } from "@/features/account/types/Verification";

export const useIsVerified = (): boolean => {
  const userId = useUserId();
  const { profile, isLoading } = useProfile();

  const verificationStatus = profile?.userVerificationStatus;

  const [cachedVerificationStatus, setCachedVerificationStatus] =
    useLocalStorage<boolean>(
      `userVerificationStatus:${userId ?? "anonymous"}`,
      true,
    );

  useEffect(() => {
    if (isLoading || !profile) return;

    if (typeof verificationStatus === "undefined") {
      setCachedVerificationStatus(false);
      return;
    }

    setCachedVerificationStatus(
      USER_VERIFIED_STATUSES.includes(verificationStatus),
    );
  }, [isLoading, verificationStatus]);

  return cachedVerificationStatus;
};
